import NewProjectWizardReducer from './NewProjectWizardReducer';

export default from './NewProjectWizardContainer';
export const NewProjectWizardReducers = {
  NewProjectWizardReducer,
};
